//@flow
import React, { Component } from "react";

type Props = {
  productCode: number,
  onRemove: (productCode: number) => void
};

class RemoveWishlistButton extends Component<Props> {
  render() {
    const productCode: number = this.props.productCode;
    const { onRemove } = this.props;
    return (
      <button
        className="wishlist-tile__remove-btn"
        tabIndex="-1"
        onClick={onRemove.bind(this, productCode)}
      >
        <i className="zmdi zmdi-close-circle" />
      </button>
    );
  }
}

export default RemoveWishlistButton;
